import type { User } from 'firebase/auth';

export interface State {
  error: Error | null;
  isReady: boolean;
  isSigningIn: boolean;
  user: User | null;
}

type Action =
  | { type: 'AUTH_STATE_CHANGED'; user: User | null }
  | { type: 'AUTH_ERROR'; error: Error }
  | { type: 'SIGNIN_START' }
  | { type: 'SIGNIN_DONE' }
  | { type: 'SIGNIN_ERROR'; error: Error }
  | { type: 'SIGN_OUT_DONE' };

export const INITIAL_STATE: State = {
  error: null,
  isReady: false,
  isSigningIn: false,
  user: null,
};

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'AUTH_STATE_CHANGED':
      return {
        ...state,
        error: null,
        isReady: true,
        user: action.user,
      };
    case 'AUTH_ERROR':
      return {
        ...state,
        error: action.error,
        isReady: false,
        user: null,
      };
    case 'SIGNIN_START':
      return {
        ...state,
        error: null,
        isSigningIn: true,
      };
    case 'SIGNIN_DONE':
      return {
        ...state,
        isSigningIn: false,
      };
    case 'SIGNIN_ERROR':
      return {
        ...state,
        error: action.error,
        isReady: false,
        isSigningIn: false,
      };
    case 'SIGN_OUT_DONE':
      return {
        ...state,
        isReady: true,
        user: null,
      };
    default:
      return state;
  }
}
